/* ==========================================================================
   LUJE — size guide dialog.

   The theme's size-guide trigger ships with class `hidden` and was un-hidden by
   the FoxKit script, which then filled a modal with that app's demo content.
   FoxKit is uninstalled — there is no `foxecom-bs-kit` metafield definition
   left on the shop — so the trigger either stayed hidden or opened "example
   content". This owns both ends instead: it reveals the trigger only when a
   real size guide is present on the page, and opens it.

   A native <dialog> does the hard parts correctly on its own: focus is trapped,
   Escape closes, the backdrop is inert, and focus returns to the trigger on
   close. No library, and no hand-rolled focus management to get wrong.
   ========================================================================== */
(function () {
  'use strict';

  function wire() {
    var dialog = document.getElementById('luje-size-guide');
    if (!dialog || dialog.__lujeWired) return;
    dialog.__lujeWired = true;

    // Only advertise the guide if there is actually one to show.
    document.querySelectorAll('[data-open-sizeguide]').forEach(function (btn) {
      btn.classList.remove('hidden');
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        if (typeof dialog.showModal === 'function') dialog.showModal();
        else dialog.setAttribute('open', '');   // very old browsers: inline, still readable
      });
    });

    dialog.querySelectorAll('[data-close-sizeguide]').forEach(function (btn) {
      btn.addEventListener('click', function () { dialog.close(); });
    });

    // Click on the backdrop (i.e. outside the panel) closes it.
    dialog.addEventListener('click', function (e) {
      if (e.target === dialog) dialog.close();
    });
  }

  document.addEventListener('DOMContentLoaded', wire);
  wire();

  // Product content can be swapped in by the theme (quick view, variant
  // re-render), so pick up a dialog that arrives later.
  new MutationObserver(wire).observe(document.documentElement, { childList: true, subtree: true });
})();
